'use strict';

import React from "react";
import { action, observable, configure, flow, makeObservable } from "mobx";
configure({enforceActions: 'always'});
import {normalize} from "@uw-it-sis/lib-react-myplan/lib/CourseUtils";

import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import events from "@uw-it-sis/lib-react/lib/Events";
import PlanEvents from "@uw-it-sis/lib-react-myplan/lib/PlanEvents";

class ScheduleBuilderOptionCourseStore {
    state = States.initial;

    data = {};

    courseActivities = [];

    // This array contains the initial list of planned activities
    initialPlannedActivities = [];

    // Captures duplicate secondary selection
    duplicateSecondary = {};

    // Stores primary activities
    primaryActivities = {};

    constructor() {
        makeObservable(this, {
            state: observable,
            mount: action,
            updateSelection: action
        });

        // list of user selected activities
        this.data.selectedActivities = {};
    }

    mount(props) {
        this.state = States.pending;

        this.courseActivities = props.preparedActivities;
        this.data.selectedActivities = {};

        this.courseActivities.map((activity, index) => {
            let name = this.getActivityName(activity);

            // Will need this in case of secondary activity selections
            if (activity.primary) {
                this.primaryActivities[name] = activity;
            }

            if (props.planData && props.planData.includes(name)) {
                this.initialPlannedActivities.push(name);
                this.data.selectedActivities[name] = activity;
            }
        });

        this.state = States.done;
    }

    /**
     * Updates the user selection of activities. If a secondary activity is selected but the primary isn't, selects the primary
     * If the primary was selected and then unselected, unselect the secondary too. If the user selects multiple secondaries of
     * the same type, populates duplicate secondaries which is used to warn the user
     *
     * @param code  activityOfferingId of the activity
     * @param selected true/false based on whether the activity is selected
     * @param activity
     */
    updateSelection(code, selected, activity) {

        this.state = States.pending;
        this.duplicateSecondary = {};

        // if selected and not in the list
        if(selected && this.data.selectedActivities[code] === undefined) {

            if(!activity.primary) {

                // Make sure that another secondary of the same type is not selected.
                for (const key in this.data.selectedActivities) {
                    if(activity.activityTypeDescription === this.data.selectedActivities[key].activityTypeDescription) {
                        this.duplicateSecondary[code] = this.data.selectedActivities[key];
                    }
                }

                // Make sure that the primary is also selected if the activity is a secondary
                if(this.data.selectedActivities[activity.parentActivityId] === undefined) {
                    this.data.selectedActivities[activity.parentActivityId] = this.primaryActivities[activity.parentActivityId];
                }
            }

            this.data.selectedActivities[code] = activity;
        } else if (!selected && this.data.selectedActivities[code] !== undefined) {

            //Unselect everything if it is a primary
            if (activity.primary) {
                this.data.selectedActivities = {};
            } else {
                delete this.data.selectedActivities[code];
            }
        }

        const eventObject = {
            dirty: this.isDirty(this.initialPlannedActivities, this.data.selectedActivities),
            duplicateSecondary: (this.duplicateSecondary && this.duplicateSecondary[code]),
            selectedActivityCodes: this.getSelectedActivityCodes(this.data.selectedActivities),
            eventType: "planItemSelectionUpdated"
        };
        events.emit(PlanEvents.planItemSelectionUpdated, eventObject);
        this.state = States.done;
    }

    getCourseActivities() {
        return this.courseActivities;
    }

    getDuplicateSecondaries() {
        return this.duplicateSecondary;
    }

    getActivityName(activity) {
        return activity.activityOfferingId;
    }

    getSelectedActivityCodes(selectedActivities) {
        let selectedActivityCodes = [];
        for (const key in selectedActivities) {
            selectedActivityCodes.push(`${normalize(selectedActivities[key].courseCd)} ${selectedActivities[key].activityCode}`);
        }
        return selectedActivityCodes;
    }

    /**
     * Checks if the user selected activities are different planned activities
     * @param initialPlannedActivities
     * @param selectedActivities
     * @returns {boolean}
     */
    isDirty(initialPlannedActivities, selectedActivities){
        let selectedKeys = [];
        let dirty = false;
        for (const key in selectedActivities) {
            selectedKeys.push(key);
        }

        if(initialPlannedActivities.length !== selectedKeys.length) {
            dirty = true;
        } else {
            selectedKeys.map(key =>{
               if (!initialPlannedActivities.includes(key)){
                   dirty = true;
               }
            });
        }
        return dirty;

    }
}

export default ScheduleBuilderOptionCourseStore;